export default "__VITE_ASSET__D1FWMrIW__"